import { render, staticRenderFns } from "./Centro.vue?vue&type=template&id=6bf1bf24"
import script from "./Centro.vue?vue&type=script&lang=js"
export * from "./Centro.vue?vue&type=script&lang=js"
import style0 from "./Centro.vue?vue&type=style&index=0&id=6bf1bf24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports